import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

const initialState = {
    order: EMPTY_ARRAY
};
/*
const searchSuccess = (state, action) => {
    console.log(action);
    let clips = { ...state.clips };
    let elements;
    if (action.payload.clips && action.payload.clips.objects && action.payload.clips.objects.elements)
        elements = action.payload.clips.objects.elements;
    else if (action.payload.clips && action.payload.clips.clip && action.payload.clips.clip.elements)
        elements = action.payload.clips.clip.elements;

    Object.keys(elements).forEach(id => {
        let element = elements[id];
        clips[id] = Clip.parseClip(element, state.playerDerivatives);
        // element.addEventListener('update', (e) => { console.log("UPDATE EVENT"); });
    });

    return updateObject(state, { clips: updateObject(state.clips, clips), order: [ ...state.order, ...action.payload.clips.order ] });
}*/

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SEARCH_SUCCESS: 
            console.log("-----------------------------------------------");
            console.log(state, action);
            //state.order = [ ...state.order, ...action.payload.clips.order ];
            return updateObject(state, { order: [ ...state.order, ...action.payload.clips.order ] });
        default:
            return state;
    }
}

export default reducer;
